/*
 * (c) Meta Platforms, Inc. and its affiliates.
 */

import React from "react";
import MetaAILogo_A from "../../assets/branding/metaAI-regular-logo.png";
import MetaAILogo_B from "../../assets/branding/metaAI-white-logo.svg";
import { AiFillInfoCircle } from "react-icons/ai";

interface FooterProps {
  position: "fixed" | "absolute" | "relative";
  variant?: "light" | "dark";
}

function Footer({ position, variant }: FooterProps) {
  return (
    <footer
      className={`footer flex flex-row-reverse items-center justify-between ${position} bottom-0 p-4 text-base-content font-bold z-10 touch-none ${
        variant === "dark" && "bg-black"
      }`}
    >
      <img
        className="mx-2 w-20 h-3 lg:w-auto text-left touch-none"
        src={variant !== "light" ? MetaAILogo_B : MetaAILogo_A}
        alt=""
      />
      <a
        className="touch-auto"
        href="https://www.facebook.com/maps/attribution_terms"
        target="_blank"
        rel="noreferrer"
      >
        <AiFillInfoCircle size={22} />
      </a>
    </footer>
  );
}

export default Footer;
